import React from "react";
import { Box, Container, Grid } from "@mui/material";
import applestor from "../../../assets/images/applestor.png";
import playstor from "../../../assets/images/playstor.png";
import { Link } from "react-router-dom";
import { styled } from "@mui/material/styles";

const Footerstyled = styled("footer")(({ theme }) => ({
  background: theme.palette.primary.main,
  padding: "15px 0",
}));
const MainTitle = styled("h6")(({ theme }) => ({
  fontFamily: theme.typography.fontFamily,
  color: "#fff",
  fontStyle: "normal",
  fontWeight: 900,
  fontSize: "20px",
  lineHeight: "33px",
  marginBottom: "2px",
}));

const MainDesc = styled("p")(({ theme }) => ({
  fontFamily: theme.typography.fontFamily,
  fontStyle: "normal",
  fontWeight: 400,
  fontSize: "15px",
  lineHeight: "20px",
  color: "#FFFFFF",
}));
const SocialMain = styled(Box)(({ theme }) => ({
  display: "flex",
  gap: "20px",
  justifyContent: "end",
  alignItems: "center",
  [theme.breakpoints.down("sm")]: {
    justifyContent: "center",
  },
  [theme.breakpoints.down("md")]: {
    justifyContent: "center",
  },
}));
const SocialImage = styled("img")(({ theme }) => ({
  maxWidth: "100%",
  height: "60px",
  [theme.breakpoints.down("sm")]: {
    height: "auto",
  },
  [theme.breakpoints.down("md")]: {
    height: "auto",
  },
}));

const MyGridItem = styled(Grid)({
  "&.css-1hhgieh-MuiGrid-root": {
    paddingTop: 0,
    marginTop: "auto",
  },
});
const MobileText = styled("footer")(({ theme }) => ({
  fontFamily: theme.typography.fontFamily,
  fontStyle: "normal",
  fontWeight: 600,
  fontSize: "14px",
  lineHeight: "15px",
  color: "#fff",
  justifyContent: "center",
}));

const Footer = () => {
  return (
    <>
      <Footerstyled>
        <Container maxWidth="lg">
          <Grid container spacing={3}>
            <MyGridItem item xs={12} md={6} lg={6}>
              <MainTitle sx={{ display: { xs: "none", md: "flex" } }}>
                Download Techify Now
              </MainTitle>
              <MainDesc sx={{ display: { xs: "none", md: "flex" } }}>
                Fast, Simple & Delightful <br /> All it takes is 30 seconds to
                Download
              </MainDesc>
              <MobileText
                sx={{ display: { xs: "flex", md: "none", lg: "none" } }}
              >
                Download App
              </MobileText>
            </MyGridItem>
            <MyGridItem item xs={12} md={6} lg={6} sx={{ marginTop: "auto" }}>
              <SocialMain>
                <Link to="#">
                  <SocialImage src={applestor} alt="applestor" />
                </Link>
                <Link to="#">
                  <SocialImage src={playstor} alt="applestor" />
                </Link>
              </SocialMain>
            </MyGridItem>
          </Grid>
        </Container>
      </Footerstyled>
    </>
  );
};

export default Footer;
